var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11526_41816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.10415 9.10502C5.95985 9.24213 5.72244 9.24213 5.57814 9.10502L4.08856 7.71217C3.94193 7.57723 3.94193 7.35525 4.08856 7.22031C4.23286 7.0832 4.47026 7.0832 4.61457 7.22031L5.84115 8.36724L8.18491 6.17567C8.32922 6.03856 8.56662 6.03856 8.71092 6.17567C8.85755 6.3106 8.85755 6.53259 8.71092 6.66752L6.10415 9.10502ZM3.97917 1.89481H8.44792V0.850167C8.44792 0.657866 8.61549 0.501953 8.82031 0.501953C9.02513 0.501953 9.19271 0.657866 9.19271 0.850167V1.89481H9.9375C10.7591 1.89481 11.4271 2.51833 11.4271 3.28767V10.252C11.4271 11.0202 10.7591 11.6448 9.9375 11.6448H2.48958C1.66682 11.6448 1 11.0202 1 10.252V3.28767C1 2.51833 1.66682 1.89481 2.48958 1.89481H3.23438V0.850167C3.23438 0.657866 3.40195 0.501953 3.60677 0.501953C3.81159 0.501953 3.97917 0.657866 3.97917 0.850167V1.89481ZM1.74479 10.252C1.74479 10.6372 2.07832 10.9484 2.48958 10.9484H9.9375C10.3495 10.9484 10.6823 10.6372 10.6823 10.252V4.68052H1.74479V10.252ZM1.74479 3.28767V3.9841H10.6823V3.28767C10.6823 2.90246 10.3495 2.59124 9.9375 2.59124H2.48958C2.07832 2.59124 1.74479 2.90246 1.74479 3.28767Z",
    fill: "#30307D",
    stroke: "#30307D",
    strokeWidth: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11526_41816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.c0f3cd36fbeaa359a5838cc958590202.svg";
export { ForwardRef as ReactComponent };